import { AuthService } from '@/app/core/auth/auth.service'
import { ChatStore } from '@/app/features/chat/store/chat.store'
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  untracked,
} from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { Toast } from 'primeng/toast'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  template: `
    <router-outlet />
    <p-toast />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private authService = inject(AuthService)
  private chatStore = inject(ChatStore)

  constructor() {
    effect(() => {
      const isAuthenticated = this.authService.isAuthenticated()
      untracked(() => {
        if (isAuthenticated) {
          this.chatStore.init()
        } else {
          this.chatStore.reset()
        }
      })
    })
  }
}
